/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_PublishInputs */

const en_statement_taxonomy_editor_publish = /** @type {(inputs: Statement_Taxonomy_Editor_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const nl_statement_taxonomy_editor_publish = /** @type {(inputs: Statement_Taxonomy_Editor_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publiceren`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Statement_Taxonomy_Editor_PublishInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_publish = /** @type {((inputs?: Statement_Taxonomy_Editor_PublishInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_PublishInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_publish(inputs)
	return en_statement_taxonomy_editor_publish(inputs)
});